import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  FEEDBACK_ALL,
  FEEDBACK_CREATE,
  FEEDBACK_EDIT,
  FEEDBACK_FORM,
  FEEDBACK_FORM_ALL,
  FEEDBACK_FORM_CREATE,
  FEEDBACK_FORM_DELETE,
  FEEDBACK_FORM_LIST,
  FEEDBACK_LIST,
  FEEDBACK_TYPES,
  FEEDBACK_UPDATE,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const feedbackAll = createAsyncThunk(
  FEEDBACK_ALL,
  async (params: PayloadCreatorParams<`${typeof API.FEEDBACK_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.feedbackAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const feedbackCreate = createAsyncThunk(
  FEEDBACK_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.FEEDBACK}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.feedbackCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const feedbackEdit = createAsyncThunk(
  FEEDBACK_EDIT,
  async (params: PayloadCreatorParams<`${typeof API.FEEDBACK_EDIT}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.feedbackEdit(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const feedbackForm = createAsyncThunk(
  FEEDBACK_FORM,
  async (params: PayloadCreatorParams<`${typeof API.FEEDBACK_FORM}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.feedbackForm(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const feedbackFormAll = createAsyncThunk(
  FEEDBACK_FORM_ALL,
  async (params: PayloadCreatorParams<`${typeof API.FEEDBACK_FORM_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.feedbackFormAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const feedbackFormCreate = createAsyncThunk(
  FEEDBACK_FORM_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.FEEDBACK_FORM}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.feedbackFormCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const feedbackFormDelete = createAsyncThunk(
  FEEDBACK_FORM_DELETE,
  async (params: PayloadCreatorParams<`${typeof API.FEEDBACK_FORM}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.feedbackFormDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const feedbackFormList = createAsyncThunk(
  FEEDBACK_FORM_LIST,
  async (params: PayloadCreatorParams<`${typeof API.FEEDBACK_FORM}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.FeedbackFormList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const feedbackList = createAsyncThunk(
  FEEDBACK_LIST,
  async (params: PayloadCreatorParams<`${typeof API.FEEDBACK}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.feedbackList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const feedbackTypes = createAsyncThunk(
  FEEDBACK_TYPES,
  async (params: PayloadCreatorParams<`${typeof API.FEEDBACK_TYPES}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.feedbackTypes(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const feedbackUpdate = createAsyncThunk(
  FEEDBACK_UPDATE,
  async (params: PayloadCreatorParams<`${typeof API.FEEDBACK_UPDATE}`, 'put'>, { rejectWithValue }) => {
    try {
      const response = await api.feedbackUpdate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const feedbackAllClear = createAction(`${FEEDBACK_ALL}/clear`)

export const feedbackListClear = createAction(`${FEEDBACK_LIST}/clear`)

export const feedbackTypesClear = createAction(`${FEEDBACK_TYPES}/clear`)

export const feedbackEditClear = createAction(`${FEEDBACK_EDIT}/clear`)

export const feedbackFormClear = createAction(`${FEEDBACK_FORM}/clear`)

export const feedbackFormAllClear = createAction(`${FEEDBACK_FORM_ALL}/clear`)

export const feedbackFormListClear = createAction(`${FEEDBACK_FORM_LIST}/clear`)
